import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../pages/Login.vue';

Vue.use(VueRouter);

const routes = [
  {
    name: 'Login',
    path: '/Login',
    component: Login,
    meta: { title: 'SPHEREboard' },
  },
];

const router = new VueRouter({ routes });

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'SPHEREboard';
  next();
  return;
});

export default router;
